import isClient from '../isClient/index.js';

/*
  Since we will target IE11 more often than both IE11 and Edge, IE11 is the default.
  However, the version param allows for edge cases (no pun intended) where both
  IE11 and Edge need to be identified.
*/

var isMicrosoftBrowser = (function (version) {
  // Support SSR by checking if on client. Assume not Microsoft browser otherwise.
  // TODO: Is it okay to assume it's not a Microsoft browser when rendering on the server?
  if (!isClient()) return false;
  var bodyStyle = window.document.body.style;
  var isBothIEAndEdge = bodyStyle.msTextCombineHorizontal !== undefined;
  var isOnlyIE = isBothIEAndEdge && bodyStyle.outlineOffset === undefined;

  if (version === 'all') {
    return isBothIEAndEdge;
  }

  return isOnlyIE;
});

export default isMicrosoftBrowser;
